import { render, staticRenderFns } from "./sample2.vue?vue&type=template&id=3a760b2e&scoped=true&lang=pug&"
var script = {}
import style0 from "./sample2.vue?vue&type=style&index=0&id=3a760b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a760b2e",
  null
  
)

export default component.exports